import { notification } from 'antd';

notification.config({
  top: 65,
});

export default notification;
